import { hydrateRoot } from 'react-dom/client';
import { ReactRelayContext, RelayEnvironmentProvider } from 'react-relay';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import SV from 'server-vars';
import { ServerVarsContextProvider } from '../shared/ServerVarsContext.tsx';

import {
    ProjectRootQuery,
    type ProjectRootQueryType,
} from '../interiorsProject/ProjectRootQuery.ts';
import { type InteriorProjectWrapper_viewer$key } from '../interiorsProject/__generated__/InteriorProjectWrapper_viewer.graphql.ts';
import InteriorProjectWrapper from '../interiorsProject/InteriorProjectWrapper.tsx';
import { getEnvironment } from '../relayModernEnvironment.ts';

const environment = getEnvironment(true);

const locale = SV.get('locale');
const messages = SV.get('messages');
const isPreview = SV.get('isPreview') || false;
const variables: ProjectRootQueryType['variables'] = SV.get('relayVariables');

const operation = createOperationDescriptor(getRequest(ProjectRootQuery), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    const interiorProjectDOMNode = document.getElementById('js-root');

    if (interiorProjectDOMNode !== null) {
        hydrateRoot(
            interiorProjectDOMNode,
            <IntlProvider locale={locale} messages={messages}>
                <ServerVarsContextProvider
                    isMobile={SV.get('settings.isMobile')}
                    isTablet={SV.get('settings.isTablet')}
                    isDesktop={SV.get('settings.isDesktop')}
                >
                    <RelayEnvironmentProvider environment={environment}>
                        <ReactRelayContext value={{ environment }}>
                            <InteriorProjectWrapper
                                isPreview={isPreview}
                                viewer={snapshot?.data?.viewer as InteriorProjectWrapper_viewer$key}
                            />
                        </ReactRelayContext>
                    </RelayEnvironmentProvider>
                </ServerVarsContextProvider>
            </IntlProvider>
        );
    }
});
